import type { Context, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const makeBaseProvider = <T,>(Context: Context<T>) =>
  function BaseProvider({ children, ...value }: Props & T) {
    return <Context.Provider value={value as T}>{children}</Context.Provider>;
  };
